import { observer } from 'mobx-react';
import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import * as React from 'react';

export interface FileProviderViewProps {
    icon: JSX.Element;
    name: string;
    onClick: () => void;
    ariaLabel: string;
    isSelected?: boolean;
}

const classNames = require('classnames');
const styles = require('./FileProviderView.scss');

@observer
export default class FileProviderView extends React.Component<FileProviderViewProps, {}> {
    render() {
        const { name } = this.props;
        const filePickerViewStyles = classNames([
            styles.container,
            { [styles.providerSelected]: this.props.isSelected },
        ]);

        const ariaProps: AriaProperties = {
            role: AriaRoles.button,
            label: this.props.ariaLabel,
        };

        return (
            <div
                className={filePickerViewStyles}
                data-is-focusable={true}
                onClick={e => this.props.onClick()}
                {...generateDomPropertiesForAria(ariaProps)}>
                <div className={styles.providerImage}>{this.props.icon}</div>

                {/* The container for the provider name */}
                <div className={styles.providerInformationContainer}>
                    <div className={styles.providerName}>{name}</div>
                </div>
            </div>
        );
    }
}
